
import { Seed } from "./Seed";
import { Panel } from "./wrappers/Panel";

export const SeedBar = () => {
  return (<Panel>
    <Seed />
  </Panel>);
};